import React from "react";

// Bande opaque sous la barre de navigation Android (3 boutons / geste) : le contenu qui défile
// ne passe plus « sous » les boutons système. Hauteur = --sa-bottom → 0 sur le web / desktop.
export const NavBarBackdrop = () => (
  <div
    aria-hidden
    className="fixed bottom-0 left-0 right-0 z-[45] pointer-events-none"
    style={{ height: "var(--sa-bottom)", background: "var(--yalola-bg)" }}
    data-testid="nav-bar-backdrop"
  />
);
